import {DataTableColumn} from "mantine-datatable";
import {Meter} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {StatusBadge} from "../profile/StatusBadge.tsx";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";

export const useTableColumns = () => {

    const columns: DataTableColumn<Meter>[] = [
        {
            accessor: 'name',
            title: I18n.get('Meter'),
            width: '1fr',
        },
        {
            accessor: 'apiKey',
            title: I18n.get('API key'),
            width: '1fr',
            render: (item: Meter) => item.apiKey,
        },
        {
            accessor: 'type',
            title: I18n.get('Type'),
            width: '1fr',
            render: (item: Meter) => item.type,
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: Meter) => <StatusBadge status={item.status}/>,
        },
        {
            accessor: 'dimensions',
            title: I18n.get('Dimensions'),
            width: '1fr',
            render: (item: Meter) => item.dimensions ? item.dimensions.length : '-',
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: Meter) => formatTimestamp(item.created as string),
        },

    ];

    return {
        columns,
    }
}
